import { render, staticRenderFns } from "./MenuEdit.vue?vue&type=template&id=d3ea2568&"
import script from "./MenuEdit.vue?vue&type=script&lang=js&"
export * from "./MenuEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports